import React from 'react';
import styled from 'styled-components';

import { Alert, AlertProps } from '@material-ui/lab';

const StyledAlert = styled(Alert)`
  margin-left: -30px;
  margin-right: -30px;
  padding-left: 30px;
  padding-right: 30px;
  justify-content: center;
  a {
    text-decoration: underline;
  }
`;

const PageTemplateAlert: React.FC<AlertProps> = ({ children, ...props }) => {
  return <StyledAlert {...props}>{children}</StyledAlert>;
};

export default PageTemplateAlert;
